module.exports = __webpack_public_path__ + "static/img/preheat_head.e85552d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preheat_head.png
// module id = ljRe
// module chunks = 1